import isHS from "@/vue/planning/logic/hs"

// Config
import {wiypFeature} from "@/config/ABTestFeatures"
import { wiypActive } from '@/config/ABTestExperiments';

// Logic
import isABTestActive from "@/logic/isABTestActive"

export const getPrestCrossedPrice = (prest, isHaveQuoteResponse) => {
	if (!prest.maxPromo) return null
	if (!prest.crossedPrice || prest.crossedPrice === 0)
		throw new Error("crossedPrice must exist and be a positive number")

	if (prest.maxPromo < 5) return null

	// const isActive = isABTestActive(wiypFeature, wiypActive)
	const isActive = true // set to true for now until the problem with Kameleoon is fixed
	if (isHS(prest) || isHaveQuoteResponse || isActive) {
		return prest.crossedPrice
	} else {
		return prest.crossedPrice * prest.maxCapacity
	}
}

const priceWithoutFee = (prest) => {
	if (!prest.pricePerLogementWithoutFee) return null
	if (prest.pricePerLogementWithoutFee <= 0)
		throw new Error("pricePerLogementWithoutFee must be a positive number")
	return prest.pricePerLogementWithoutFee
}

const priceWithFee = (prest) => {
	if (!prest.pricePerLogement) return null
	if (prest.pricePerLogement <= 0)
		throw new Error("pricePerLogement must be a positive number")
	return prest.pricePerLogement
}

export const getPriceAccommodationOnly = (prest) => {
	if (!prest.priceAccommodationOnly) return null
	if (prest.priceAccommodationOnly <= 0)
		throw new Error("priceAccommodationOnly must be a positive number")
	return prest.priceAccommodationOnly
}

export const getPrestTotalPrice = (prest) => {
	const prestPriceWithFee = priceWithFee(prest)
	const prestPriceWithoutFee = priceWithoutFee(prest)
	return !isHS(prest) && prestPriceWithoutFee
		? prestPriceWithoutFee
		: prestPriceWithFee
}

export const getPrestPerPrice = (prest, participantsNum) => {
	const prestPriceWithFee = priceWithFee(prest)
	const prestPriceWithoutFee = priceWithoutFee(prest)
	return !isHS(prest) && prestPriceWithoutFee
		? prestPriceWithoutFee / participantsNum
		: prestPriceWithFee / participantsNum
}

export const getPrestMaxPromo = (prest) => {
	if (!prest.maxPromo) return null
	return prest.maxPromo >= 5 ? prest.maxPromo : null
}

export const getMaxPromo = (promo) => {
	return promo >= 5 ? promo : null
}